// removed by extract-text-webpack-plugin
module.exports = {"link-list":"_23DG7vRn","linkList":"_23DG7vRn","link":"_3nx8e930"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetails/LinkList/LinkList.pcss
// module id = 785
// module chunks = 0